/*
  Sets all given props in the digital data layer
 */

import { Component } from "react";
import PropTypes from "prop-types";
import lodashGet from "lodash.get";
import AnalyticsContext from "../analytics-context";

class AnalyticsPageContext extends Component {
  state = {
    analytics: {
      digitalData: {},
      ddlIsDirty: false
    },
    pageName: "",
    pageNameChanged: false
  };

  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      pageName: props.pageName,
      pageNameChanged: props.pageName !== state.pageName
    };
  }

  // Set values to null by default so that incorrect data isn't reused in another call.
  triggerPageContext = () => {
    const url = lodashGet(window, "location.href") || null;
    const {
      pageId = null,
      pageName = null,
      pageType = null,
      rawPageName = null,
      environment = null
    } = this.props;

    if (pageName && pageName.length > 0 && this.state.pageNameChanged) {
      this.context.actions.updateDigitalData({
        pageId,
        pageName,
        pageType,
        url,
        rawPageName,
        environment
      });
    }
  };

  componentDidMount() {
    this.triggerPageContext();
  }

  shouldComponentUpdate(nextProps) {
    const {
      pageId,
      pageName,
      pageType,
      events,
      rawPageName,
      environment
    } = this.props;

    return (
      pageId !== nextProps.pageId ||
      pageName !== nextProps.pageName ||
      pageType !== nextProps.pageType ||
      events !== nextProps.events ||
      rawPageName !== nextProps.rawPageName ||
      environment !== nextProps.environment
    );
  }

  componentDidUpdate() {
    this.triggerPageContext();
  }

  render() {
    return null;
  }
}

AnalyticsPageContext.contextType = AnalyticsContext;

AnalyticsPageContext.propTypes = {
  pageId: PropTypes.string,
  pageName: PropTypes.string,
  pageType: PropTypes.string,
  events: PropTypes.string,
  rawPageName: PropTypes.string,
  environment: PropTypes.string
};

export default AnalyticsPageContext;
